import { InjectionToken } from '@angular/core';
import { abTestConfigInterface } from './interfaces/abTestConfig.interface';

export const CONFIG = new InjectionToken<abTestConfigInterface[]>('ANGULAR_AB_TEST_CONFIG');
